import React, {Component} from 'react';
import axios from 'axios';
import auth0Client from '../Auth';
import {withRouter} from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
//import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import {ToastContainer, ToastStore} from 'react-toasts';
//import Modal from 'react-responsive-modal';
import {SERVER_URL}  from '../Constants';
import Toggle from "react-toggle-component"

const { SearchBar } = Search;

const columns = [
  
  { dataField: 'userName', text: 'User Name', classes:'text-primary', sort: true, headerAlign: 'center',align: 'right',headerStyle: {whiteSpace:'nowrap',width:'450px' }},
  { dataField: 'lastName', text: 'Last', classes:'text-primary', sort: true, headerAlign: 'center',align: 'right'},
  { dataField: 'firstName', text: 'First',classes:'text-primary', sort: true, headerAlign: 'center',align: 'right'},
  { dataField: 'employeeId', text: 'Employee Id',classes:'text-primary', sort: true, headerAlign: 'center',align: 'center'},
  { dataField: 'phone', text: 'Phone', classes:'text-primary', sort: true, headerAlign: 'center',align: 'center'},
  { dataField: 'isActive', text: 'Active', classes:'text-primary', filterable:true, sort: true, headerAlign: 'center',align: 'center', formatter: activeStatusFieldFormatter},
  { dataField: 'securityGroup', text: 'ROLE', classes:'text-primary',sort: true, headerAlign: 'center',align: 'center'},
  { dataField: 'lfReadOnly', text: 'L&F Read Only', classes:'text-primary',sort: true, headerAlign: 'center',align: 'center', formatter: readOnlyStatusFieldFormatter},
  { dataField: 'ptReadOnly', text: 'PT Read Only', classes:'text-primary',sort: true, headerAlign: 'center',align: 'center',formatter: readOnlyStatusFieldFormatter}


];

const paginationOption = {
  custom: true,
  sizePerPage: 50
};


const defaultSorted = [{
  dataField: 'userName',
  order: 'desc'
}];

/*function imageFormat(cell, row){
  if (row.pic){
      return (
          <img  src={row.pic} width={75} alt={row.shortDescription} />
      )
  }
}*/
function readOnlyStatusFieldFormatter(cell,row){
  if (cell!==undefined){
    return (cell===true) ? 'YES' : 'NO';
  }else{
    return 'NO';
  }
}

function activeStatusFieldFormatter(cell,row){
  if (cell!==undefined){
    return (cell===true) ? 'YES' : 'NO';
  }
}


class Users extends Component {
  constructor(props) {
    super(props);

    this.state = {
        users: [],
        showNew: false,
        email:'',
        disabled: false,
        searchButtonTitle: 'Invite user',
        error: null,
        showAddNewUser: (auth0Client.getSecurityGroup()==='admin'),
        sso:false,
        ssoDomain: '',
        showInactive:true,
        filteredUsers:[],
    };

    this.rowEvents = {
      onClick: (e, row, rowIndex) => {
        
        this.props.history.push('/User/' + row.id);
        //console.log(this + ' ' + `clicked on row with index: ${rowIndex}`);
        
    
      },
      
    };


  }

  async componentDidMount() {
    console.log('Loading users');
    this.loadUsers();
    axios.get(`${SERVER_URL}/venue/` + auth0Client.getActiveVenuedId(),{
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }
    }).then((res)=>{
        const venue = res.data;
        this.setState({
            sso: venue.sso,
            ssoDomain:venue.ssoDomain
        });
     
    });

  }

 
loadUsers =async () =>{
  const users = (await axios.get(`${SERVER_URL}/Users/`,{
    headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
    'venueId' : auth0Client.getActiveVenuedId()
   }
  })).data;
  // remove bounte.net users if any

  let filteredUsers = users.filter((u)=>{
      return (!u.userName.includes('bounte.net'))
  })


  this.setState({
      users : filteredUsers,
      filteredUsers:filteredUsers
  });

}

  handleInputChange=(event) =>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
}


submit= async()=>{

  if (!this.state.email){
    ToastStore.error('Missing email address');
    return;
    
  }

 

  this.setState({
    disabled: true,
    searchButtonTitle: 'locating...'
  });

  await axios.post(`${SERVER_URL}/Users/AddUser/` + this.state.email, {
  
    // empty body
  }, {
  headers: { 
    'Authorization': `Bearer ${auth0Client.getIdToken()}`,
    'venueId': auth0Client.getActiveVenuedId()
  
  }
})
.then((res)=>{
    //this.props.history.push('/');
    // Show saved successful
   // console.log('results :'+ res);
    if (res.status===200){
       
      this.loadUsers();
      ToastStore.success('User Saved Successfully!');
    }else{
      console.log('response error ');
      ToastStore.error(res.message);
    }
    this.setState({
      showAlert:false,
      disabled: false,
      showSuccess: true,

  });
  
})
.catch ((e)=>{
  console.log('results error:'+ e.response.data.message);
    this.setState({
        showAlert:true,
        disabled: false,
        error:e.response.data.message,

    })
    ToastStore.error(this.state.error.response.data);
})






  this.setState({
    disabled: false,
    searchButtonTitle: 'Locate User and Add'
  });

  
}




 showNew=()=>{
   this.setState({ showNew: true});

 }
  


 renderAddNew=()=>{

   if (this.state.showAddNewUser){
     return (
      <div className='alert alert-dismissible alert-success'>
      <div className ='col'>   
      
            <h6 htmlFor="exampleInputEmail1"> + Add new user: Invite the user to join.  They will receive a welcome email and registration information.</h6>
            <input
              disabled={this.state.disabled}
              type="email"
              onChange={this.handleInputChange}
              name="email"
              className="form-control"
              placeholder="user's email address"
              value= {this.state.email}
            />
   
            

           
            <div className ='col'> 
            <button type="button" disabled={this.state.disabled}  onClick={()=>{this.submit()}} className="btn btn-success" >{this.state.searchButtonTitle}</button>
  </div>          
</div>
</div>

     );
   }else{
     return (null);
   }
 }


 includeInactive=(value)=>{

  let filteredUsers = this.state.users.filter((u)=>{
   
    return (u.isActive || (u.isActive===false && value))
  })

  this.setState({
    showInactive:value,
    filteredUsers: filteredUsers
  })
 }
 

  render() {
    return (

      <div className="container-fluid">
        <h2>Users</h2>
        <p className='text-danger'><b> {(this.state.sso) ? "This is an SSO-enabled account for " + this.state.ssoDomain : ''}</b></p>
        <br/>
        
       
          {this.state.users === null && <p>Loading Users...</p>}
          {this.renderToast()}

         
      <br/>
      <h4> Existing Users </h4>

                <ToolkitProvider 
        bootstrap4
          keyField='id' 
          data={ this.state.filteredUsers } 
          columns={ columns }
          defaultSorted={defaultSorted}
          search
          >
          {
    props => (
      <div>
       
       <div className='row'>
          <div className='col-6 text-left'>
                <SearchBar { ...props.searchProps } />
          </div>
          <div className='col-6 text-right'>
                <Toggle className='text-right text-primary' id='expensive' labelRight="Include Inactive Users" checked={this.state.showInactive} onToggle={value => this.includeInactive(value)} /> 
          </div>
       </div>
      
       
        <hr />
        <BootstrapTable
        
          striped
          hover
          condensed
          rowEvents={this.rowEvents}
          
          { ...props.baseProps }
          pagination={ paginationFactory(paginationOption) }
        />
      </div>
    )
  }</ToolkitProvider>

   {this.renderAddNew()}

    
      




        </div>


    
    )
  }
}

export default withRouter(Users);